<script setup lang="ts">
import { useConfigStore } from '@core/stores/config'
import AboutUsCharacters from '@/views/front-pages/landing-page/about-us-characters.vue'
import AboutUsComic from '@/views/front-pages/landing-page/about-us-comic.vue'
import AboutUsFeatures from '@/views/front-pages/landing-page/about-us-features.vue'
import AboutUsTestimonials from '@/views/front-pages/landing-page/about-us-testimonials.vue'

import AboutUsTimeline from '@/views/front-pages/landing-page/about-us-timeline.vue'

const store = useConfigStore()

store.skin = 'default'

definePageMeta({
  layout: 'front-page',
  public: true,
  pageTitle: {
    title: 'Over \'t SpeelFabrik',
    subtitle: 'ontdek wie we zijn en wat ons uniek maakt',
    icon: 'bx-star',
    iconColor: 'primary',
  },
})

useSeoMeta({
  title: 'Over \'t SpeelFabrik - Onze Visie en Waarden',
  description: 'Ontdek wie we zijn en wat \'t SpeelFabrik uniek maakt. Leer meer over onze visie, waarden en wat onze avontuurlijke kinderkampen speciaal maakt.',
  ogTitle: 'Over \'t SpeelFabrik - Onze Visie en Waarden',
  ogDescription: 'Ontdek wie we zijn en wat \'t SpeelFabrik uniek maakt. Leer meer over onze visie en waarden.',
  ogType: 'website',
  ogUrl: 'https://www.tspeelfabrik.be/over-speelfabrik',
  ogImage: 'https://www.tspeelfabrik.be/images/og-about.jpg',
  robots: 'index, follow',
})

useHead({
  meta: [
    { name: 'keywords', content: 'SpeelFabrik, over ons, kinderkampen, jeugdwerk, visie, waarden, missie' },
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://www.tspeelfabrik.be/over-speelfabrik',
    },
  ],
})
</script>

<template>
  <div class="landing-page-wrapper">
    <AboutUsComic />
    <AboutUsTimeline />
    <AboutUsCharacters />
    <AboutUsTestimonials style="display: none;" />
    <AboutUsFeatures style="display: none;" />
  </div>
</template>

<style lang="scss" scoped>
.landing-page-wrapper {
  background-color: rgb(var(--v-theme-surface));
}
</style>
